import { AbsatzVorgabe } from '@/domain/controlling/entities';

export function calculateUmsatzZielminuten(
  planwert: number | undefined,
  produktivitaet: number | undefined,
) {
  if (planwert && produktivitaet) {
    const zielstunden = Math.round((planwert / produktivitaet) * 60);
    return zielstunden;
  }
  return undefined;
}

export function calculatAbsatzZielminuten(
  planwert: number | undefined,
  produktivitaet: number | undefined,
  absatzVorgabe: AbsatzVorgabe,
) {
  if (planwert && produktivitaet) {
    const produktivitaetInStueck =
      absatzVorgabe === AbsatzVorgabe.Stueck
        ? produktivitaet
        : Number((60 / produktivitaet).toFixed(2));
    const zielstunden = Math.round((planwert / produktivitaetInStueck) * 60);
    return zielstunden;
  }
  return undefined;
}
